import { Fragment, useState } from "react";

import Timer from "../../../../../components/Timer";
import HexModal from "../../../../../components/HexModal";
import { getLabel } from "../../../../../hooks/use-labels";

import { getReservationExpiry } from "../payment-utils";

import FailedPayment from "../../../../../components/PaymentProcessor/components/FailedPayment";

import { removeLocalStorageItems } from "../../../../../utils/common-utils";
import "./style.css";

const ReservationExpiryTimer = ({ goBackToSummary }) => {
  const [reservationFailure, setReservationFailure] = useState(false);

  const onReservationFailure = () => {
    removeLocalStorageItems("reservationInfo");
    setReservationFailure(true);
  };

  return (
    <Fragment>
      {reservationFailure && (
        <HexModal open={true} modalClass="reservation-expiry-time-modal">
          <FailedPayment
            title={getLabel("reservationExpiryTitle")}
            message={getLabel("reservationFailureMessage")}
            buttonLabel={getLabel("okayText")}
            onClick={goBackToSummary}
          />
        </HexModal>
      )}

      {!reservationFailure && (
        <div className={"expiry-msg font-14-normal-400-lh-16"}>
          {getLabel("orderReservationMessage")}
          <Timer
            minutes={getReservationExpiry()}
            onComplete={onReservationFailure}
          />
        </div>
      )}
    </Fragment>
  );
};

export default ReservationExpiryTimer;
